import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {ServiceType} from "../../../deliveries/types/service.type";
import {RecurringType} from "../../../commons/types/recurring.type";
import {OperatorEnum} from "../../../commons/angular/enums/operator.enum";
import {ClusteringMode} from "../../types/clustering-mode.type";
import {
  buildDefaultDayTimeTemplate,
  PLANNING_FILTER_DAY_LABELS,
  PLANNING_FILTER_DAYS
} from "../../models/planning-draft-layer.model";
import {PlanningServerEnum} from "../../../scheduling-project/enums/planning-server.enum";
import {SelectorType} from "../../enums/selector-type.enum";
import {getMetersPerLargeDistanceUnit} from "../../../commons/utils/distance-unit.util";

const PROBABILITY_RATIO_FIELD_NAMES: string[] = [
  'probabilityConstraintRatioUser',
  'probabilityConstraintRatioDay',
  'probabilityConstraintRatioGeneral'
];

export class PlanningProjectSettingsFormCtrl implements IController {
  form: any;
  project?: any;
  settings: any;
  depots?: any;
  depotIds?: any;
  isFirstSection: boolean;
  template?: any;
  draft?: any;
  selectedJobs: any;
  isDisableForm: boolean;
  draftTemplate: any;
  isShowDeliveryAddressSelect: boolean;
  isShowFieldServiceAddressSelect: boolean;
  isLayerMode: boolean;
  isTemplateMode: boolean;
  hideLayeredPlanningTab: boolean;
  showLayerInfoBanner: boolean;
  optimizationStep: any;
  onChange: Function;
  onTemplateChange: Function;
  onDraftChange: Function;
  onOptimizationStepChange: Function;
  onClusteringAreasUpdated: Function;

  public settingsCopy: any;
  public isServiceTimeSectionExpanded: boolean = true;
  public isOptimizationSectionExpanded: boolean = true;
  public siteDistanceUnit: string;
  public distributionServicesInfo: any = {
    count: 0,
    total: undefined
  }
  public siteInfo: any;
  public serviceTypes: typeof ServiceType = ServiceType;
  public selectedTab: string;
  private options: { trafficStates: any, optimizationTypes: any, roadRestrictions: any, locationTypes: any };
  private currencyUnit: any;
  private isRecurring: any;
  public days: any;
  public dispatchScheduleSettingsTime?: string;
  public dispatchScheduleSettingsDays?: string;
  public templateSettingsCopy: any;
  public vehiclePriorityExcludedIds: string[];
  public startOfDay: any;
  public endOfDay: any;
  public operatorOptions = Object.values(OperatorEnum)
  public clusteringMode: typeof ClusteringMode = ClusteringMode;
  public showDynamicClusteringSettings: boolean;
  public showCreateDraftInheritedProjectClusteringAreas: boolean;
  public showDraftClusteringAreas: boolean;
  public showTemplateClusteringAreas: boolean;
  public showProjectClusteringAreas: boolean;
  public filterDayOptions = PLANNING_FILTER_DAYS;
  public filterDayLabels = PLANNING_FILTER_DAY_LABELS;
  public filterTimeOptions: string[];
  public readonly planningServerTypes: string[] = Object.values(PlanningServerEnum);
  public selectorTypes = Object.values(SelectorType);
  public defaultCoreOptimizationSetup: any;
  public isCustomWeightsSumValid: boolean = true;
  public hasCoreOptimizationPermission: boolean = true;


  /* @ngInject */
  constructor(private $scope: any, private planningConstants, private splitService, private siteContextService: SiteContextService,
              private moment, private commonsConstants) {

    this.defaultCoreOptimizationSetup = angular.copy(planningConstants.defaultCoreOptimizationSetup);

    this.options = {
      trafficStates: planningConstants.trafficStates,
      optimizationTypes: planningConstants.optimizationTypes,
      roadRestrictions: planningConstants.roadRestrictions,
      locationTypes: planningConstants.locationTypes
    };


  }

  $onInit() {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.currencyUnit = this.splitService.getCurrencySymbol();
    this.siteDistanceUnit = this.splitService.getSiteDistanceLargeUnit(true);
    this.startOfDay = this.moment().startOf('day').valueOf();
    this.endOfDay = this.moment().endOf('day').valueOf();
    this.filterTimeOptions = this._buildFilterTimeOptions();

    // if (_.isUndefined(this.isShowDeliveryAddressSelect)) {
    //   this.isShowDeliveryAddressSelect = _.find(this.selectedJobs, job => {
    //     return job.jobType === "Delivery";
    //   });
    // }
    //
    // if (_.isUndefined(this.isShowFieldServiceAddressSelect)) {
    //   this.isShowFieldServiceAddressSelect = _.find(this.selectedJobs, job => {
    //     return job.jobType === "Operation"
    //   })
    // }

    this.distributionServicesInfo.total = this.selectedJobs?.length || 0;

    this.settingsCopy = angular.copy(this.settings);

    this._initClusteringSettings();
    this._initStopToStopSettings();
    this._initProbabilityConstraintSettings();
    this._initMinimizeBundleVisitsConstraintSettings();
    this._initTripUtilizationConstraintSettings();

    this.$scope.$applyAsync(() => {
      this._revalidateFields(PROBABILITY_RATIO_FIELD_NAMES);
      this._validateProbabilityRatioSum();
      this._validateThresholdOrder();
      this._validateThresholdSum();
    });

    if (this.template && !this.template.clusteringAreaIds) {
      this.template.clusteringAreaIds = [];
    }

    if (this.draft && !this.draft.clusteringAreaIds) {
      this.draft.clusteringAreaIds = [];
    }

    if (this.project && !this.project.clusteringAreaIds) {
      this.project.clusteringAreaIds = [];
    }

    if (!this.settings.planningServer) {
      this.settingsCopy.planningServer = PlanningServerEnum.DEFAULT;
    }

    if (!this.settings.prioritySettings) {
      this.settingsCopy.prioritySettings = {}
    }


    if (!this.settings.driverLocationSettings) {
      this.settingsCopy.driverLocationSettings = {}
    }

    if (!this.settings.serviceLocationSettings) {
      this.settingsCopy.serviceLocationSettings = {}
    }

    // if (!_.get(this.settings, 'driverLocationSettings.departurePointType', false)) {
    //   this.settingsCopy.driverLocationSettings.departurePointType = this.options.locationTypes[0];
    // }
    //
    // if (!_.get(this.settings, 'driverLocationSettings.destinationPointType', false)) {
    //   this.settingsCopy.driverLocationSettings.destinationPointType = this.options.locationTypes[0];
    // }
    //
    // if (!_.get(this.settings, 'serviceLocationSettings.departurePointType', false)) {
    //   this.settingsCopy.serviceLocationSettings.departurePointType = 'UNDEFINED';
    // }
    //
    // if (!_.get(this.settings, 'serviceLocationSettings.destinationPointType', false)) {
    //   this.settingsCopy.serviceLocationSettings.destinationPointType = 'UNDEFINED';
    // }

    if (_.get(this.settings, 'driverLocationSettings.departurePointType') === 'DEPOT') {
      if (!this.settingsCopy.driverLocationSettings.departureId && _.get(this.depots, 'length')) {
        this.settingsCopy.driverLocationSettings.departureId = _.get(this.depots, '[0].id');
      }
    }

    if (_.get(this.settings, 'driverLocationSettings.destinationPointType') === 'DEPOT') {
      if (!this.settingsCopy.driverLocationSettings.destinationId && _.get(this.depots, 'length')) {
        this.settingsCopy.driverLocationSettings.destinationId = _.get(this.depots, '[0].id');
      }
    }

    if (_.get(this.settings, 'serviceLocationSettings.departurePointType') === 'DEPOT') {
      if (!this.settingsCopy.serviceLocationSettings.departureId && _.get(this.depots, 'length')) {
        this.settingsCopy.serviceLocationSettings.departureId = _.get(this.depots, '[0].id');
      }
    }

    if (_.get(this.settings, 'serviceLocationSettings.destinationPointType') === 'DEPOT') {
      if (!this.settingsCopy.serviceLocationSettings.destinationId && _.get(this.depots, 'length')) {
        this.settingsCopy.serviceLocationSettings.destinationId = _.get(this.depots, '[0].id');
      }
    }

    this.selectedTab = !!this.template ? 'Project' : (this.isLayerMode ? 'Filters' : 'Optimization');

    this.checkCustomWeightsSumValidity();

    if (this.template) {
      this.isRecurring = {
        enabled: !!this.template?.projectTemplateScheduleSettings
      };

      this.days = angular.copy(this.commonsConstants.daysCheckboxConfig);

      if (this.template.projectTemplateScheduleSettings?.eventSchedule?.byWeekDay?.length) {
        _.forOwn(this.days, (value, key) => {
          if (_.includes(this.template.projectTemplateScheduleSettings.eventSchedule.byWeekDay, key)) {
            value.enabled = true;
          }
        })
      }

      if (!this.template.dispatchScheduleSettings) {
        this.template.dispatchScheduleSettings = {};
      }

      if (this.template.dispatchScheduleSettings?.time) {
        this.dispatchScheduleSettingsTime = this.moment(this.template.dispatchScheduleSettings.time, 'HH:mm').valueOf();
      }

      if (Number.isNaN(this.template.dispatchScheduleSettings.cutOffDay)) {
        this.template.dispatchScheduleSettings.cutOffDay = 0
      }
    }

    if (!!this.project && !this.isLayerMode && this.settingsCopy.optimizationSteps?.length) {
      this.settingsCopy.optimizationSteps.forEach((os) => {
        if (os.resourceFilter) {
          const notBefore = os.resourceFilter.notBefore;
          const notAfter = os.resourceFilter.notAfter;

          let isBetweenProjectRange =
            this.moment(notBefore).isBetween(this.moment(this.project.from), this.moment(this.project.to)) &&
            this.moment(notAfter).isBetween(this.moment(this.project.from), this.moment(this.project.to))

          if (!isBetweenProjectRange) {
            os.resourceFilter.notBefore = notBefore ?
              this._getUpdatedTimeByDate(this.project.from, notBefore) :
              this.moment(this.project.from).startOf('day').valueOf();
            os.resourceFilter.notAfter = notAfter ?
              this._getUpdatedTimeByDate(this.project.from, notAfter) :
              this.moment(this.project.from).endOf('day').valueOf();
          }

        }
        if (os.jobFilter) {
          const notBefore = os.jobFilter.notBefore;
          const notAfter = os.jobFilter.notAfter;

          let isBetweenProjectRange =
            this.moment(notBefore).isBetween(this.moment(this.project.from), this.moment(this.project.to)) &&
            this.moment(notAfter).isBetween(this.moment(this.project.from), this.moment(this.project.to));

          if (!isBetweenProjectRange) {
            os.jobFilter.notBefore = notBefore ?
              this._getUpdatedTimeByDate(this.project.from, notBefore) :
              this.moment(this.project.from).startOf('day').valueOf();
            os.jobFilter.notAfter = notAfter ?
              this._getUpdatedTimeByDate(this.project.from, notAfter) :
              this.moment(this.project.from).endOf('day').valueOf();
          }

        }
      })
    }

    if (this.isLayerMode && this.isTemplateMode && this.optimizationStep) {
      this._ensureDayTimeTemplates(this.optimizationStep);
    }


  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.settings && !onChangesObj.settings.isFirstChange()) {
      if (!_.isEqual(this.settingsCopy, this.settings)) {
        this.settingsCopy = angular.copy(this.settings);
        this._initClusteringSettings();
        this._initStopToStopSettings();
        this._initProbabilityConstraintSettings();
        this._initMinimizeBundleVisitsConstraintSettings();
        this._initTripUtilizationConstraintSettings();
        this.checkCustomWeightsSumValidity();
      }
    }
    if (onChangesObj.draft || onChangesObj.selectedJobs || onChangesObj.template || onChangesObj.project) {
      this._syncClusteringVisibility();
    }
    if (onChangesObj.isFirstSection && !onChangesObj.isFirstSection.isFirstChange()) {
      if (!this.isFirstSection) {
        this.selectedTab = !!this.template ? 'Project' : (this.isLayerMode ? 'Filters' : 'Optimization');
        this.$scope.$applyAsync(() => {
          this._revalidateFields(PROBABILITY_RATIO_FIELD_NAMES);
          this._validateThresholdOrder();
          this._validateThresholdSum();
        });
      }
    }
    if (onChangesObj.optimizationStep && !onChangesObj.optimizationStep.isFirstChange() && this.isLayerMode && this.isTemplateMode) {
      this._ensureDayTimeTemplates(this.optimizationStep);
    }
  }

  // ******************************
  //        Public methods
  // ******************************

  onSelectTab(tab) {
    this.selectedTab = tab;
  }

  onOptimizationStepTagsOperatorChange() {
    this._notifyOptimizationStepChange();
  }

  onDriverLocationSettingsChange(driverLocationSettings) {
    this.settingsCopy.driverLocationSettings = driverLocationSettings;
    if (this.settingsCopy.distribution) {
      this.servicesNotWithinSelectedAddressCounter();
    }
    this.onSettingsChange(this.settingsCopy);
  }

  onServiceAgentLocationSettingsChange(serviceLocationSettings) {
    this.settingsCopy.serviceLocationSettings = serviceLocationSettings;
    if (this.settingsCopy.distribution) {
      this.servicesNotWithinSelectedAddressCounter();
    }
    this.onSettingsChange(this.settingsCopy);
  }

  onAddPriorityStep() {
    if (!this.settingsCopy.prioritySettings.slaPriority) {
      this.settingsCopy.prioritySettings.slaPriority = [];
    }

    const previousStep = _.get(this.settingsCopy.prioritySettings.slaPriority, this.settingsCopy.prioritySettings.slaPriority.length - 1, {});
    const step = {slaInHours: (previousStep.slaInHours ? previousStep.slaInHours + 1 : 24), priority: 5};

    this.settingsCopy.prioritySettings.slaPriority.push(step);
    this.onSettingsChange(this.settingsCopy);
  }

  onAddVehiclePriority() {
    if (!this.settingsCopy.prioritySettings.vehiclePriorities) {
      this.settingsCopy.prioritySettings.vehiclePriorities = [];
    }

    const vehiclePriority = {
      vehicleId: undefined,
      priority: 1
    }

    this.settingsCopy.prioritySettings.vehiclePriorities.push(vehiclePriority);
    this.onSettingsChange(this.settingsCopy);
  }

  onSelectPlanningServer(planningServer: PlanningServerEnum) {
    this.settingsCopy.planningServer = planningServer;
    this.onSettingsChange(this.settingsCopy);
  }

  onVehiclePrioritySelect(index, vehicle) {
    this.settingsCopy.prioritySettings.vehiclePriorities[index].vehicleId = vehicle.id;
    this._setVehiclePriorityExcludedIds();
    this.onSettingsChange(this.settingsCopy);
  }

  onRemoveVehiclePriority(index) {
    this.settingsCopy.prioritySettings.vehiclePriorities.splice(index, 1);
    this._setVehiclePriorityExcludedIds();
    this.onSettingsChange(this.settingsCopy);
  }

  private _setVehiclePriorityExcludedIds() {
    this.vehiclePriorityExcludedIds = this.settingsCopy.prioritySettings.vehiclePriorities.map((vehiclePriority) => vehiclePriority.vehicleId);
  }

  onChangePriorityStep(slaInHours, index) {
    const previousStep = _.get(this.settingsCopy.prioritySettings.slaPriority, index - 1);
    if (previousStep && previousStep.slaInHours >= slaInHours) {
      this.settingsCopy.prioritySettings.slaPriority[index].slaInHours = (previousStep.slaInHours + 1);
    }
    this.onSettingsChange(this.settingsCopy);
  }

  onRemovePriorityStep(index) {
    this.settingsCopy.prioritySettings.slaPriority.splice(index, 1);
    this.onSettingsChange(this.settingsCopy);
  }


  onToggleDistribution(value) {
    this.settingsCopy.distribution = value;
    if (value) {
      this.servicesNotWithinSelectedAddressCounter();
    } else {
      this.settingsCopy.minRouteDuration = null;
      this.settingsCopy.maxRouteDuration = null;
    }
    this.onSettingsChange(this.settingsCopy)
  }


  onConsiderRouteIncomeChange(isEnabled) {
    if (!isEnabled && this.settingsCopy.incomeSettings) {
      this.settingsCopy.incomeSettings.minRouteIncome = null;
      this.settingsCopy.incomeSettings.maxRouteIncome = null;
    }

    this.onSettingsChange(this.settingsCopy);
  }

  onPenaltyBasedOnVehicleFixCostChange(isEnabled) {
    if (!isEnabled && this.settingsCopy.incomeSettings) {
      this.settingsCopy.incomeSettings.penaltyFactorBasedOnVehicleFixCost = null;
    }

    this.onSettingsChange(this.settingsCopy);
  }

  onSettingsChange(updatedSettings) {
    if (this.isLayerMode) {
      _.unset(updatedSettings, 'optimizationSteps');
    }
    if (_.isFunction(this.onChange)) {
      this.onChange({settings: updatedSettings})
    }
  }

  onClusteringModeChange() {
    this._syncClusteringVisibility();
    this.onSettingsChange(this.settingsCopy);
  }

  onToggleCoreOptimization(enabled: boolean) {
    if (enabled) {
      this.settingsCopy.coreOptimizationSetup = angular.copy(this.defaultCoreOptimizationSetup);
    } else {
      this.settingsCopy.coreOptimizationSetup = null;
    }
    this.checkCustomWeightsSumValidity();
    this.onSettingsChange(this.settingsCopy);
  }

  enableCoreOptimizationSection() {
    this.hasCoreOptimizationPermission = true;
  }

  disableCoreOptimizationSection() {
    this.hasCoreOptimizationPermission = false;
  }

  checkCustomWeightsSumValidity() {
    const setup = this.settingsCopy?.coreOptimizationSetup;
    if (!setup) {
      this.isCustomWeightsSumValid = true;
      if (this.form && typeof this.form.$setValidity === 'function') {
        this.form.$setValidity('customWeightsSumValid', true);
      }
      return;
    }
    const sum = (setup.customClusterWeight || 0) + (setup.customRadialWeight || 0) + (setup.customRandomWeight || 0)
      + (setup.customWorstWeight || 0) + (setup.customStringWeight || 0);
    this.isCustomWeightsSumValid = sum > 0.0;
    if (this.form && typeof this.form.$setValidity === 'function') {
      this.form.$setValidity('customWeightsSumValid', this.isCustomWeightsSumValid);
    }
  }

  get stopToStopDistanceLimit(): number | undefined {
    return this._metersToLargeDistanceUnit(this._stopToStopDistanceConstraint.distanceLimit);
  }

  set stopToStopDistanceLimit(value: number | undefined) {
    this._stopToStopDistanceConstraint.distanceLimit = this._largeDistanceUnitToMeters(value);
  }

  get stopToStopHighTierEnabled(): boolean {
    const constraint = this._stopToStopDistanceConstraint;
    return !_.isNil(constraint.highDistanceLimit) ||
      !_.isNil(constraint.highWeight) ||
      this._isStopToStopFieldCleared('stopToStopHighDistanceLimit');
  }

  set stopToStopHighTierEnabled(enabled: boolean) {
    const constraint = this._stopToStopDistanceConstraint;
    if (enabled) {
      constraint.highDistanceLimit = !_.isNil(constraint.distanceLimit) ? constraint.distanceLimit : 0;
      constraint.highWeight = !_.isNil(constraint.weight) ? constraint.weight : 0;
    } else {
      delete constraint.highDistanceLimit;
      delete constraint.highWeight;
      this._clearStopToStopFieldValue('stopToStopHighDistanceLimit');
    }
    this.onSettingsChange(this.settingsCopy);
  }

  get stopToStopHighDistanceLimit(): number | undefined {
    return this._metersToLargeDistanceUnit(this._stopToStopDistanceConstraint.highDistanceLimit);
  }

  set stopToStopHighDistanceLimit(value: number | undefined) {
    this._stopToStopDistanceConstraint.highDistanceLimit = this._largeDistanceUnitToMeters(value);
  }

  get stopToStopHardLimitEnabled(): boolean {
    return !_.isNil(this._stopToStopDistanceConstraint.hardDistanceLimit) ||
      this._isStopToStopFieldCleared('stopToStopHardDistanceLimit');
  }

  set stopToStopHardLimitEnabled(enabled: boolean) {
    const constraint = this._stopToStopDistanceConstraint;
    if (enabled) {
      const fallback = !_.isNil(constraint.highDistanceLimit) ? constraint.highDistanceLimit : constraint.distanceLimit;
      constraint.hardDistanceLimit = !_.isNil(fallback) ? fallback : 0;
    } else {
      delete constraint.hardDistanceLimit;
      this._clearStopToStopFieldValue('stopToStopHardDistanceLimit');
    }
    this.onSettingsChange(this.settingsCopy);
  }

  get stopToStopHardDistanceLimit(): number | undefined {
    return this._metersToLargeDistanceUnit(this._stopToStopDistanceConstraint.hardDistanceLimit);
  }

  set stopToStopHardDistanceLimit(value: number | undefined) {
    this._stopToStopDistanceConstraint.hardDistanceLimit = this._largeDistanceUnitToMeters(value);
  }

  onStopToStopDistanceLimitChange() {
    this.onSettingsChange(this.settingsCopy);
    this._revalidateFields(['stopToStopHighDistanceLimit', 'stopToStopHardDistanceLimit']);
  }

  onStopToStopHighDistanceLimitChange() {
    this.onSettingsChange(this.settingsCopy);
    this._revalidateFields(['stopToStopHardDistanceLimit']);
  }

  onStopToStopHardDistanceLimitChange() {
    this.onSettingsChange(this.settingsCopy);
  }

  private _revalidateFields(fieldNames: string[]) {
    _.forEach(fieldNames, (name) => {
      const field = this._getSecondSectionField(name);
      if (field && _.isFunction(field.$validate)) {
        field.$validate();
      }
    });
  }

  onClusteringAreaIdsChange(clusteringAreaIds) {
    if (this.template) {
      this.template.clusteringAreaIds = clusteringAreaIds;
      this._onTemplateChange(this.template);
    } else if (this.draft) {
      this.draft.clusteringAreaIds = clusteringAreaIds;
      this._onDraftChange(this.draft);
    } else if (this.project) {
      this.project.clusteringAreaIds = clusteringAreaIds;
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onClusteringAreasChange(clusteringAreas) {
    if (_.isFunction(this.onClusteringAreasUpdated)) {
      this.onClusteringAreasUpdated({clusteringAreas: clusteringAreas});
    }
  }

  private _notifyOptimizationStepChange() {
    if (this.isLayerMode && _.isFunction(this.onOptimizationStepChange)) {
      this.onOptimizationStepChange({optimizationStep: this.optimizationStep});
    }
  }

  onChangeTemplateBranchIds(branchIds) {
    this.template.branchIds = branchIds;
    this._onTemplateChange(this.template);
  }

  onChangeTemplateDefaultDraft(draftTemplateId: string, draftTemplate: any) {
    this.template.draftTemplateId = draftTemplateId;
    this.draftTemplate = draftTemplate;
    this._onTemplateChange(this.template);
  }

  onToggleUseDraftTemplateSettings() {
    this.template.useDraftTemplateSettings = !this.template.useDraftTemplateSettings;
    if (this.template.useDraftTemplateSettings) {
      this.templateSettingsCopy = angular.copy(this.template.settings);
      this.template.settings = this.draftTemplate.settings;
    } else {
      this.template.settings = this.templateSettingsCopy;
    }
    this.isDisableForm = this.template.useDraftTemplateSettings;
    this._onTemplateChange(this.template);
  }

  onTemplateRecurringEnabledChange(isEnabled) {
    if (isEnabled) {
      this.template.projectTemplateScheduleSettings = {
        eventSchedule: {
          startTime: this.moment().startOf('day').valueOf(),
          endTime: this.moment().endOf('day').valueOf(),
          startRecurring: this.moment().startOf('day').valueOf(),
          endRecurring: undefined,
          interval: 1,
          freq: RecurringType.DAILY,
          zoneIdName: this.splitService.getTimeZone()
        },
        cutOffHours: undefined
      }
    } else {
      this.template.projectTemplateScheduleSettings = undefined;
    }
    this._onTemplateChange(this.template);
  }

  onTemplateRecurringChange(type: RecurringType) {
    if (!type) {
      this.template.projectTemplateScheduleSettings.eventSchedule.interval = 1;
    }
    this.template.projectTemplateScheduleSettings.eventSchedule.freq = type;
    this.template.projectTemplateScheduleSettings.eventSchedule.zoneIdName = this.splitService.getTimeZone();
    this._onTemplateChange(this.template);
  }

  onTemplateStartRecurringChange(from, to) {
    this.template.projectTemplateScheduleSettings.eventSchedule.startTime = from;
    this.template.projectTemplateScheduleSettings.eventSchedule.endTime = to;
    this.template.projectTemplateScheduleSettings.eventSchedule.startRecurring = from;
    this.template.projectTemplateScheduleSettings.eventSchedule.zoneIdName = this.splitService.getTimeZone();

    this._onTemplateChange(this.template);
  }

  onTemplateEndRecurringChange(date) {
    this.template.projectTemplateScheduleSettings.eventSchedule.endRecurring = date;
    this.template.projectTemplateScheduleSettings.eventSchedule.zoneIdName = this.splitService.getTimeZone();

    this._onTemplateChange(this.template);
  }

  onTemplateDaysChange() {
    this.template.projectTemplateScheduleSettings.eventSchedule.byWeekDay = [];
    _.forOwn(this.days, (value, key) => {
      if (value.enabled) {
        this.template.projectTemplateScheduleSettings.eventSchedule.byWeekDay.push(key);
      }
    })
  }

  onTemplateChangeDispatchScheduleSettingsTime(time) {
    if (!this.template.dispatchScheduleSettings) {
      this.template.dispatchScheduleSettings = {}
    }
    this.template.dispatchScheduleSettings.time = this.moment(time).format('HH:mm');
    this._onTemplateChange(this.template);
  }

  onTemplateDispatchScheduleSettingsTimeZoneChange(zoneId) {
    if (!this.template.dispatchScheduleSettings) {
      this.template.dispatchScheduleSettings = {}
    }
    this.template.dispatchScheduleSettings.zoneId = zoneId;
    this._onTemplateChange(this.template);
  }

  onTemplateAutoDispatchChange(autoDispatch) {
    if (!!autoDispatch) {
      if (!this.template.dispatchScheduleSettings) {
        this.template.dispatchScheduleSettings = {}
      }
      if (!this.template.dispatchScheduleSettings.zoneId) {
        this.template.dispatchScheduleSettings.zoneId = this.splitService.getSelectedTimeZone() || this.moment.tz.guess();
      }
      if (!this.template.dispatchScheduleSettings.cutOffDay) {
        this.template.dispatchScheduleSettings.cutOffDay = 0;
      }
    }
    this._onTemplateChange(this.template);
  }

  onTemplateDriverLocationSettingsChange(driverLocationSettings) {
    this.template.settings.driverLocationSettings = driverLocationSettings;
    this._onTemplateChange(this.template);
  }

  onTemplateServiceAgentLocationSettingsChange(serviceLocationSettings) {
    this.template.settings.serviceLocationSettings = serviceLocationSettings;
    this._onTemplateChange(this.template);
  }

  onServiceTimeChange(taskDetailedServiceTime, serviceTimeType, value) {
    this.settingsCopy.serviceTimeSettings[taskDetailedServiceTime][serviceTimeType] = value;
    this.onSettingsChange(this.settingsCopy);
  }

  onCreateOptimizationStep() {
    if (!this.settingsCopy.optimizationSteps) {
      this.settingsCopy.optimizationSteps = [];
    }
    const optimizationStep = {
      stepOrder: this.settingsCopy.optimizationSteps.length + 1,
      jobFilter: undefined,
      resourceFilter: undefined

    };
    this.settingsCopy.optimizationSteps.push(optimizationStep);
    this.onSettingsChange(this.settingsCopy);
  }

  onOptimizationStepRangeChange(from, to, step, ref) {
    if (!step[ref]) {
      step[ref] = {};
    }
    step[ref].notBefore = from;
    step[ref].notAfter = to;
    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onTagsChange(tags: string[], step, ref) {
    if (!step[ref]) {
      step[ref] = {};
    }
    step[ref].tags = tags;

    if (!!tags?.length && !step[ref].tagsOperator) {
      step[ref].tagsOperator = OperatorEnum.AND;
    }

    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onToggleStepFilter(step, ref) {
    if (step[ref]) {
      step[ref] = undefined;
      if (this.isTemplateMode) {
        const templateRef = ref === 'jobFilter' ? 'jobFilterDayTimeTemplate' : 'resourceFilterDayTimeTemplate';
        step[templateRef] = undefined;
      }
    } else {
      if (this.isTemplateMode) {
        const templateRef = ref === 'jobFilter' ? 'jobFilterDayTimeTemplate' : 'resourceFilterDayTimeTemplate';
        if (!step[templateRef]) {
          step[templateRef] = buildDefaultDayTimeTemplate();
        }
        step[ref] = {
          notBefore: null,
          notAfter: null,
          tags: [],
          tagsOperator: ref === 'jobFilter' ? OperatorEnum.OR : OperatorEnum.AND
        };
        step[ref].ignoreTimeWindowMatchingButOverrideTimeWindows = ref === 'jobFilter';
      } else {
        step[ref] = {
          notBefore: this.moment(this.project?.from).startOf('day').valueOf(),
          notAfter: this.moment(this.project?.from).endOf('day').set('second', 0).set('millisecond', 0).valueOf(),
          ignoreTimeWindowMatchingButOverrideTimeWindows: false
        }
      }
    }

    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onDayTimeTemplateChange(template?: any, changedField?: 'notBeforeDay' | 'notBeforeTime' | 'notAfterDay' | 'notAfterTime') {
    if (template && changedField) {
      this._autoCorrectDayTimeRange(template, changedField);
    }
    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  isDayOptionDisabled(template: any, day: string, isToDay: boolean): boolean {
    if (!template) {
      return false;
    }
    const fromRank = this._getDayRank(template.notBeforeDay);
    const toRank = this._getDayRank(template.notAfterDay);
    const dayRank = this._getDayRank(day);
    if (isToDay) {
      return dayRank < fromRank;
    }
    return dayRank > toRank;
  }

  isTimeOptionDisabled(template: any, time: string, isToTime: boolean): boolean {
    if (!template) {
      return false;
    }
    if (template.notBeforeDay !== template.notAfterDay) {
      return false;
    }
    if (isToTime) {
      return time < (template.notBeforeTime || '00:00');
    }
    return time > (template.notAfterTime || '23:59');
  }

  isDayTimeRangeInvalid(template: any): boolean {
    if (!template) {
      return false;
    }
    return this._compareDayTime(
      template.notBeforeDay, template.notBeforeTime,
      template.notAfterDay, template.notAfterTime
    ) > 0;
  }

  private _autoCorrectDayTimeRange(template: any, changedField: string) {
    const fromRank = this._getDayRank(template.notBeforeDay);
    const toRank = this._getDayRank(template.notAfterDay);

    if (changedField === 'notBeforeDay' && fromRank > toRank) {
      template.notAfterDay = template.notBeforeDay;
    } else if (changedField === 'notAfterDay' && toRank < fromRank) {
      template.notBeforeDay = template.notAfterDay;
    }

    if (template.notBeforeDay === template.notAfterDay
      && (template.notBeforeTime || '') > (template.notAfterTime || '')) {
      if (changedField === 'notAfterTime' || changedField === 'notAfterDay') {
        template.notBeforeTime = template.notAfterTime;
      } else {
        template.notAfterTime = template.notBeforeTime;
      }
    }
  }

  private _getDayRank(day: string): number {
    const idx = _.indexOf(this.filterDayOptions, day);
    return idx === -1 ? 0 : idx;
  }

  private _compareDayTime(d1: string, t1: string, d2: string, t2: string): number {
    const r1 = this._getDayRank(d1);
    const r2 = this._getDayRank(d2);
    if (r1 !== r2) {
      return r1 - r2;
    }
    if ((t1 || '') === (t2 || '')) {
      return 0;
    }
    return (t1 || '') > (t2 || '') ? 1 : -1;
  }

  onToggleStepIgnoreTimeWindowMatchingButOverrideTimeWindows(jobFilter) {
    jobFilter.ignoreTimeWindowMatchingButOverrideTimeWindows = !jobFilter.ignoreTimeWindowMatchingButOverrideTimeWindows;
    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onRemoveOptimizationStep(index) {
    this.settingsCopy.optimizationSteps.splice(index, 1)
    this.settingsCopy.optimizationSteps.forEach((s, i) => {
      s.stepOrder = i + 1;
    })
    this.onSettingsChange(this.settingsCopy);
  }

  filterTypes = [
    { value: 'tags', label: 'Tags' },
    { value: 'serviceAreas', label: 'Service area' }
  ];

  onServiceAreaIdsChange(selectedIds: string[], step, ref) {
    if (!step[ref]) step[ref] = {};
    step[ref].serviceAreaIds = selectedIds;
    if (!!selectedIds?.length && !step[ref].serviceAreasOperator) {
      step[ref].serviceAreasOperator = OperatorEnum.OR;
    }
    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onServiceAreasOperatorChange() {
    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onAddFilterRow(step, ref) {
    if (!step[ref]) step[ref] = {};
    step[ref]._showNewFilterRow = true;
    step[ref]._newFilterType = undefined;
  }

  onFilterTypeSelected(step, ref, type) {
    if (type === 'serviceAreas') {
      step[ref].serviceAreaIds = [];
      step[ref].serviceAreasOperator = OperatorEnum.OR;
      step[ref]._serviceAreasRowFilterType = 'serviceAreas';
    } else if (type === 'tags') {
      step[ref].tags = [];
      step[ref].tagsOperator = OperatorEnum.OR;
      step[ref]._tagsRowFilterType = 'tags';
    }
    step[ref]._showNewFilterRow = false;
    step[ref]._newFilterType = undefined;

    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onChangeFilterRowType(step, ref, fromType, toType) {
    if (!step[ref] || fromType === toType) {
      return;
    }

    const targetExists = toType === 'tags'
      ? step[ref].tags !== undefined
      : step[ref].serviceAreaIds !== undefined;

    if (targetExists) {
      if (fromType === 'tags') {
        step[ref]._tagsRowFilterType = 'tags';
      } else if (fromType === 'serviceAreas') {
        step[ref]._serviceAreasRowFilterType = 'serviceAreas';
      }
      return;
    }

    if (fromType === 'tags') {
      delete step[ref].tags;
      delete step[ref].tagsOperator;
      delete step[ref]._tagsRowFilterType;
    } else if (fromType === 'serviceAreas') {
      delete step[ref].serviceAreaIds;
      delete step[ref].serviceAreasOperator;
      delete step[ref]._serviceAreasRowFilterType;
    }

    if (toType === 'tags') {
      step[ref].tags = [];
      step[ref].tagsOperator = OperatorEnum.OR;
      step[ref]._tagsRowFilterType = 'tags';
    } else if (toType === 'serviceAreas') {
      step[ref].serviceAreaIds = [];
      step[ref].serviceAreasOperator = OperatorEnum.OR;
      step[ref]._serviceAreasRowFilterType = 'serviceAreas';
    }

    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  onRemoveFilter(step, ref, type) {
    if (!step[ref]) return;
    if (type === 'serviceAreas') {
      delete step[ref].serviceAreaIds;
      delete step[ref].serviceAreasOperator;
      delete step[ref]._serviceAreasRowFilterType;
    } else if (type === 'tags') {
      delete step[ref].tags;
      delete step[ref].tagsOperator;
      delete step[ref]._tagsRowFilterType;
    } else if (type === 'newRow') {
      step[ref]._showNewFilterRow = false;
      step[ref]._newFilterType = undefined;
    }

    if (this.isLayerMode) {
      this._notifyOptimizationStepChange();
    } else {
      this.onSettingsChange(this.settingsCopy);
    }
  }

  canAddMoreFilters(step, ref) {
    if (!step[ref]) return true;
    const hasTags = step[ref].tags !== undefined;
    const hasServiceAreas = step[ref].serviceAreaIds !== undefined;
    return !hasTags || !hasServiceAreas;
  }

  private _onTemplateChange(template) {
    if (_.isFunction(this.onTemplateChange)) {
      this.onTemplateChange({template: template})
    }
  }

  private _onDraftChange(draft) {
    if (_.isFunction(this.onDraftChange)) {
      this.onDraftChange({draft: draft})
    }
  }

  private servicesNotWithinSelectedAddressCounter() {

    this.distributionServicesInfo.count = 0;
    _.forEach(this.selectedJobs, job => {
      for (let i = 0; i < job.stops.length; i++) {
        if (job.stops[i].stopType === 'Pickup' && this.settingsCopy.driverLocationSettings.departurePoint) {
          if ((job.stops[i].address.location.lng !== this.settingsCopy.driverLocationSettings.departurePoint.location.lng)
            || (job.stops[i].address.location.lat !== this.settingsCopy.driverLocationSettings.departurePoint.location.lat)) {
            this.distributionServicesInfo.count += 1;
          }
          return;
        }
        if (job.stops[i].stopType === 'Dropoff' && this.settingsCopy.driverLocationSettings.destinationPoint) {
          if ((job.stops[i].address.location.lng !== this.settingsCopy.driverLocationSettings.destinationPoint.location.lng)
            || (job.stops[i].address.location.lat !== this.settingsCopy.driverLocationSettings.destinationPoint.location.lat)) {
            this.distributionServicesInfo.count += 1;
          }
          return;
        }
        if (job.stops[i].stopType === 'Operation' && this.settingsCopy.serviceLocationSettings.destinationPoint) {
          if ((job.stops[i].address.location.lng !== this.settingsCopy.serviceLocationSettings.destinationPoint.location.lng)
            || (job.stops[i].address.location.lat !== this.settingsCopy.serviceLocationSettings.destinationPoint.location.lat)) {
            this.distributionServicesInfo.count += 1;
          }
          return;
        }
      }
    })
  }

  private _getUpdatedTimeByDate(baseDate, timeToUpdate) {
    const date = this.moment(baseDate);          // date you want
    const timestamp = this.moment(timeToUpdate);   // timestamp to take time from

    date
      .hour(timestamp.hour())
      .minute(timestamp.minute())
      .second(timestamp.second())
      .millisecond(timestamp.millisecond());

    return date;
  }

  private _buildFilterTimeOptions(): string[] {
    const options: string[] = [];
    _.times(24, (h) => {
      _.forEach([0, 30], (m) => {
        options.push(`${_.padStart(_.toString(h), 2, '0')}:${_.padStart(_.toString(m), 2, '0')}`);
      });
    });
    if (!_.includes(options, '23:59')) {
      options.push('23:59');
    }
    return options;
  }

  private _initStopToStopSettings() {
    if (!this.settingsCopy.constraintConfigurations) {
      this.settingsCopy.constraintConfigurations = {};
    }
    if (!this.settingsCopy.constraintConfigurations.stopToStopDistanceConstraint) {
      this.settingsCopy.constraintConfigurations.stopToStopDistanceConstraint = {};
    }
  }

  private _initProbabilityConstraintSettings() {
    if (!this.settingsCopy.constraintConfigurations) {
      this.settingsCopy.constraintConfigurations = {};
    }
    if (!this.settingsCopy.constraintConfigurations.probabilityConstraint) {
      this.settingsCopy.constraintConfigurations.probabilityConstraint = {};
    }
  }

  private _initMinimizeBundleVisitsConstraintSettings() {
    if (!this.settingsCopy.constraintConfigurations) {
      this.settingsCopy.constraintConfigurations = {};
    }
    if (!this.settingsCopy.constraintConfigurations.minimizeBundleVisitsConstraint) {
      this.settingsCopy.constraintConfigurations.minimizeBundleVisitsConstraint = {};
    }
  }

  private _initTripUtilizationConstraintSettings() {
    if (!this.settingsCopy.constraintConfigurations) {
      this.settingsCopy.constraintConfigurations = {};
    }
    if (!this.settingsCopy.constraintConfigurations.tripUtilizationConstraint) {
      this.settingsCopy.constraintConfigurations.tripUtilizationConstraint = {};
    }
    if (_.isNil(this.settingsCopy.constraintConfigurations.tripUtilizationConstraint.lateRunCutoffRatio)) {
      this.settingsCopy.constraintConfigurations.tripUtilizationConstraint.lateRunCutoffRatio = 0.9;
    }
  }

  get enableConstraintConfiguration(): boolean {
    return this.splitService.getSiteInfo()?.enableConstraintConfiguration ?? false;
  }

  private get _stopToStopDistanceConstraint() {
    return this.settingsCopy.constraintConfigurations.stopToStopDistanceConstraint;
  }

  private get _probabilityConstraint() {
    return this.settingsCopy.constraintConfigurations.probabilityConstraint;
  }

  private _safeRatio(value: any): number {
    return _.isFinite(value) && value >= 0 ? value : 0;
  }

  get ratioUserMaxLimit(): number {
    return 1 - this._safeRatio(this._probabilityConstraint.ratioDay) - this._safeRatio(this._probabilityConstraint.ratioGeneral) + Number.EPSILON;
  }

  get ratioDayMaxLimit(): number {
    return 1 - this._safeRatio(this._probabilityConstraint.ratioUser) - this._safeRatio(this._probabilityConstraint.ratioGeneral) + Number.EPSILON;
  }

  get ratioGeneralMaxLimit(): number {
    return 1 - this._safeRatio(this._probabilityConstraint.ratioUser) - this._safeRatio(this._probabilityConstraint.ratioDay) + Number.EPSILON;
  }

  get probabilityRatioSum(): number {
    const constraint = this._probabilityConstraint;
    return this._safeRatio(constraint.ratioUser) + this._safeRatio(constraint.ratioDay) + this._safeRatio(constraint.ratioGeneral);
  }

  onProbabilityConstraintRatioChange(changedField: string) {
    this.onSettingsChange(this.settingsCopy);
    this._revalidateFields(PROBABILITY_RATIO_FIELD_NAMES.filter((name) => name !== changedField));
    this._validateProbabilityRatioSum();
  }

  private _validateProbabilityRatioSum() {
    const isValid = Math.abs(this.probabilityRatioSum - 1) < Number.EPSILON;
    PROBABILITY_RATIO_FIELD_NAMES.forEach((name) => {
      const field = this._getSecondSectionField(name);
      if (field) {
        field.$setValidity('sum', isValid);
      }
    });
  }

  get thresholdSum(): number {
    const constraint = this._probabilityConstraint;
    return this._safeRatio(constraint.thresholdBest) + this._safeRatio(constraint.thresholdWorst);
  }

  onProbabilityConstraintThresholdChange() {
    this.onSettingsChange(this.settingsCopy);
    this._validateThresholdOrder();
    this._validateThresholdSum();
  }

  private _validateThresholdOrder() {
    const constraint = this._probabilityConstraint;
    const isValid = _.isNil(constraint.thresholdBest) || _.isNil(constraint.thresholdWorst) || constraint.thresholdBest > constraint.thresholdWorst;
    const bestField = this._getSecondSectionField('probabilityConstraintThresholdBest');
    const worstField = this._getSecondSectionField('probabilityConstraintThresholdWorst');
    if (bestField) {
      bestField.$setValidity('order', isValid);
    }
    if (worstField) {
      worstField.$setValidity('order', isValid);
    }
  }

  private _validateThresholdSum() {
    const constraint = this._probabilityConstraint;
    const isValid = _.isNil(constraint.thresholdBest) || _.isNil(constraint.thresholdWorst) || Math.abs(this.thresholdSum - 1) < Number.EPSILON;
    const bestField = this._getSecondSectionField('probabilityConstraintThresholdBest');
    const worstField = this._getSecondSectionField('probabilityConstraintThresholdWorst');
    if (bestField) {
      bestField.$setValidity('sum', isValid);
    }
    if (worstField) {
      worstField.$setValidity('sum', isValid);
    }
  }

  get stopToStopHighMinLimit(): number {
    return _.defaultTo(this.stopToStopDistanceLimit, 0);
  }

  get stopToStopHardMinLimit(): number {
    return _.defaultTo(
      this.stopToStopHighDistanceLimit,
      _.defaultTo(this.stopToStopDistanceLimit, 0)
    );
  }

  private get _largeDistanceUnitFactor(): number {
    return getMetersPerLargeDistanceUnit(this.splitService.isImperial());
  }

  private _metersToLargeDistanceUnit(meters: number | undefined): number | undefined {
    return _.isNil(meters) ? undefined : meters / this._largeDistanceUnitFactor;
  }

  private _largeDistanceUnitToMeters(value: number | undefined): number | undefined {
    return _.isNil(value) ? undefined : value * this._largeDistanceUnitFactor;
  }

  private _getSecondSectionField(fieldName: string) {
    return _.get(this.$scope, `form.SecondSection.${fieldName}`);
  }

  private _isStopToStopFieldCleared(fieldName: string): boolean {
    const field = this._getSecondSectionField(fieldName);
    return field && field.$dirty && _.isFunction(field.$isEmpty) && field.$isEmpty(field.$viewValue);
  }

  private _clearStopToStopFieldValue(fieldName: string) {
    const field = this._getSecondSectionField(fieldName);
    if (!field) {
      return;
    }
    if (_.isFunction(field.$setViewValue)) {
      field.$setViewValue(undefined);
    }
    if (_.isFunction(field.$render)) {
      field.$render();
    }
    if (_.isFunction(field.$setPristine)) {
      field.$setPristine();
    }
    if (_.isFunction(field.$setUntouched)) {
      field.$setUntouched();
    }
  }

  private _initClusteringSettings() {
    if (!this.settingsCopy.clusteringSettings) {
      this.settingsCopy.clusteringSettings = {};
    }

    const mode = this.settingsCopy.clusteringSettings.clusteringMode;
    if (mode !== ClusteringMode.DYNAMIC && mode !== ClusteringMode.CLUSTERING_AREA) {
      this.settingsCopy.clusteringSettings.clusteringMode = ClusteringMode.DYNAMIC;
    }

    this._syncClusteringVisibility();
  }

  private _syncClusteringVisibility() {
    const mode = this.settingsCopy?.clusteringSettings?.clusteringMode;
    const isServiceAreaMode = mode === ClusteringMode.CLUSTERING_AREA;
    const isPendingDraft = !!this.draft && !this.draft.id;
    const isCreateDraftContext = !!this.selectedJobs?.length && !this.template && (!this.draft || isPendingDraft);

    this.showDynamicClusteringSettings = mode === ClusteringMode.DYNAMIC;
    this.showCreateDraftInheritedProjectClusteringAreas = isServiceAreaMode && isCreateDraftContext && !!this.project && !this.draft?.id;
    this.showDraftClusteringAreas = isServiceAreaMode && !!this.draft?.id && !!this.project;
    this.showTemplateClusteringAreas = isServiceAreaMode && !!this.template;
    this.showProjectClusteringAreas = isServiceAreaMode && !!this.project && !this.draft?.id && !this.template && !isCreateDraftContext;
  }

  private _ensureDayTimeTemplates(step) {
    if (!step) {
      return;
    }
    if (step.jobFilter && !step.jobFilterDayTimeTemplate) {
      step.jobFilterDayTimeTemplate = buildDefaultDayTimeTemplate();
    }
    if (step.resourceFilter && !step.resourceFilterDayTimeTemplate) {
      step.resourceFilterDayTimeTemplate = buildDefaultDayTimeTemplate();
    }
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectSettingsForm', {
    require: {
      form: '?^form'
    },
    bindings: {
      project: '<?',
      settings: '<',
      isFirstSection: '<',
      isShowDeliveryAddressSelect: '<?',
      isShowFieldServiceAddressSelect: '<?',
      template: '<?',
      draft: '<?',
      depots: '<?',
      depotIds: '<?',
      selectedJobs: '<',
      isDisableForm: '<?',
      isLayerMode: '<?',
      isTemplateMode: '<?',
      hideLayeredPlanningTab: '<?',
      showLayerInfoBanner: '<?',
      optimizationStep: '<?',
      onChange: '&',
      onTemplateChange: '&',
      onDraftChange: '&',
      onOptimizationStepChange: '&',
      onClusteringAreasUpdated: '&?'
    },
    template: require('./planning-project-settings-form.html').default,
    controller: PlanningProjectSettingsFormCtrl
  });
